import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Input } from './Input';
import { Form } from './Form';
import { Button } from './Button';
import { Gateway } from '../BaseUrl';
import { getPhonetype, getPrimary } from '../Functions/Generic';

export class ChangeNumbers extends Component {
    displayName = ChangeNumbers.name    
    constructor(props) {
        super(props);
        this.props.changeLogo("user");
        this.state = {
            number: "",
            loading: false,
            hasError: false,
            errorMessage: "",
            sent: false,
            phoneType: 0
        }

        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        this.phoneInput = React.createRef();
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit() {
        this.setState({
            loading: true
        });
        var err = false;
        fetch(Gateway + '/User/PhoneNumber', {
            method: "POST",
            headers: {
                "Authorization": "Bearer " + this.props.token,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                Phone: {
                    Number: this.state.number,
                    TelephoneKind: getPhonetype(this.state.number),
                    ItemId: getPrimary(this.props.phoneNumbers)[0].itemId
                }
            })
        }).then(response => {
            if (response.ok) {
                return response.json();
            } else {
                if (response.status == 401) {
                    this.props.Logout(true)
                } else if (response.status == 503 || response.status == 403) {
                    throw Error(response.statusText);
                } else {
                    err = true;
                    return response.json();
                }
            }
        }).then(data => {
            if (err) {
                this.setState({
                    errorMessage: data.message,
                    sent: true,
                    hasError: true,
                    loading: false
                });
            } else {
                this.setState({
                    number: "",
                    loading: false,
                    hasError: false,
                    sent: true
                });
                this.props.updateUser();
            }
        }).catch((e) => {
            console.log("error", e);
            this.setState({
                loading: false,
                hasError: true,
                sent: true
            });
        });
    }
    
    render() {
        return (
            <div style={{ width: "100%" }}>
                <Form onSubmit={this.handleSubmit} className="page-container">
                    {
                        this.state.sent ?
                        this.state.hasError ?
                            <div>
                                <h2> Oops.. Something went wrong!</h2>
                                    <div className="error" style={{ border: "1px solid", marginBottom: "15px", padding: "5px 10px", borderRadius: "3px" }}>
                                        <i className="fas fa-exclamation-triangle" /> {this.state.errorMessage}
                                    </div>
                            </div> :
                            <div>
                                <h2>Thank you!</h2>
                                <p>Your phone number has been sucessfully added.</p>
                            </div>
                        :
                        <div>
                            <h2>Change Your Number</h2>
                        </div>
                    }
                    <label>Phone number</label>
                    <Input ref={this.phoneInput}
                        type="phone"
                        required={true}
                        rules={[
                            'isPhoneOrMobile'
                        ]}
                        getPhoneType={(type) => { this.setState({ phoneType: type }) }}
                        onChange={(e, type) => { this.setState({ number: e.target.value, phoneType: type }) }}                            
                        value={this.state.number}
                        placeholder="Phone number"
                    />                  
                    <div className="form-group">
                        <Button type="submit" loading={this.state.loading} value="Save Number" /> 
                    </div>
                    <div className="form-group">
                        <Link to={"/details"} className="btn btn-lg btn-secondary">Back to Your Details</Link>
                    </div>
                 </Form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ChangeNumbers.js